import { FC, useMemo } from 'react'
import styles from 'components/features/creditCard/creditCardComparisonChart/CardPickerNoCards/CardPickerNoCards.styl'
import { formatUSCurrency } from 'helpers/formatHelpers'

type CardPickerNoCardsProps = {
  cardsAmount: Record<'no_crypto' | 'status', number>
}
export const CardPickerNoCards: FC<CardPickerNoCardsProps> = (props) => {
  return useMemo(() => (
    <>
      <div className={ styles.item }>
        <div className={ styles.point1 } />
        <div className={ styles.title }>2% cash back invested in Bitcoin</div>
        <strong className={ styles.amount }>{ formatUSCurrency(props.cardsAmount.status) }</strong>
      </div>
      <div className={ styles.item }>
        <div className={ styles.point2 } />
        <div className={ styles.title }>2% cash back (not invested)</div>
        <strong className={ styles.amount }>{ formatUSCurrency(props.cardsAmount.no_crypto) }</strong>
      </div>
    </>
  ), [props.cardsAmount.no_crypto, props.cardsAmount.status])
}
